import {inject, Pipe, PipeTransform} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {ChargebackStatus} from '@gatewee/types/chargeback';

@Pipe({
  name: 'chargebackStatus',
  standalone: false,
})
export class ChargebackStatusPipe implements PipeTransform {
  private readonly translate = inject(TranslateService);

  transform(value: ChargebackStatus | string): string {
    return (
      this.translate.instant(`enums.chargebackStatus.${value}`) ||
      this.translate.instant('common.unknown')
    );
  }
}
